/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/CouponInfoModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/PageModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterModel.js" />
/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterItem.js" />

var SammyModel = function (pageModelHndl, model) {
    var that = this;

    that.IsPaused = ko.observable(false);

    that.resolveArticleReference = function (articleReference) {
        pageModelHndl.pProductModel.IsLoading(true);

        var input = {
            articleReference: articleReference
        };

        var url = $("#ResolveArticleReferenceUrl").val();
        return $.get(url, input)
            .fail(function () {
                alerts.error();
            }).always(function () {
                pageModelHndl.pProductModel.IsLoading(false);
            });
    };

    that.LoadProductModelData = function () {
        if (pageModelHndl.IsProductModelPopulated()) {
            return;
        }
        if (model) {
            pageModelHndl.pProductModel.PopulateProductModel(model);
            return;
        }

        $.get(ajaxUrls.order.LoadObjectConfiguration, { id: pageModelHndl.ObjectId() })
            .done(function(data) {
                if (data.Success) {
                    pageModelHndl.pProductModel.PopulateProductModel(data.Model);
                } else {
                    alerts.error();
                }
            }).fail(function () {
                alerts.error();
            });
    };

    that.LoadShowData = function (articleReference) {
        if (!pageModelHndl.IsEditMode()) {
            pageModelHndl.SubmitText(SubmitTextShoppingCart);
            pageModelHndl.CurrentHash("#/show/" + articleReference);
            pageModelHndl.EditData([]);
            pageModelHndl.IsEditDataAvailable(false);
        }
        
        return that.resolveArticleReference(articleReference).done(function(data) {
            if (!data.Success) {
                pageModelHndl.ShowData([]);
                pageModelHndl.IsShowDataAvailable(false);
                var errorMessage = $("#errorDiv2").text();
                alerts.error(errorMessage);
                return;
            }

            pageModelHndl.pProductModel.ArticleReference(articleReference);
            pageModelHndl.CurrentAmount(data.Model.Amount);

            pageModelHndl.ShowData(data);
            pageModelHndl.IsShowDataAvailable(true);
            pageModelHndl.CatalogueProductDisplayText(data.Model.DisplayText);
            pageModelHndl.IsScrollingRequired(true);

            pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues(data.Model.SelectedValues);
            pageModelHndl.pProductModel.UpdateProductModel();

            if (pageModelHndl.IsProductModelPopulated()) {
                pageModelHndl.CurrentAmount(data.Model.Amount);
                pageModelHndl.pProductModel.RePopulateProductModel(data.Model.SelectedValues);
            } else {
                that.LoadProductModelData();
            }

        });
    };

    that.LoadPositionEditData = function (editId) {
        pageModelHndl.ShowData([]);
        pageModelHndl.IsShowDataAvailable(false);
        var editUrl = $("#EditPositionUrl").val();

        return $.get(editUrl, { positionNumber: editId })
            .done(function (data) {
                if (!data.Success) {
                    pageModelHndl.EditData([]);
                    pageModelHndl.IsEditDataAvailable(false);
                    alerts.error(data.ErrorMessage);
                    return;
                }

                var result = data.Result;

                var articleReference = result.ArticleReference;
                pageModelHndl.IsEditMode(true);
                pageModelHndl.EditData(result);

                Object.keys(result.OrderOptionMap).map(function(key, index) {
                    var optionType = key;
                    var optionId = result.OrderOptionMap[key];

                    pageModelHndl.pOrderOptionsModelV2.addSelectedOrderOption(optionType, optionId, true);
                    pageModelHndl.pOrderOptionsModelV2.SelectedDeliveryCountryId(result.DeliveryCountryId);
                });
                pageModelHndl.pAdditionalWorkModelV2.SelectedAdditionalWork(result.SelectedAdditionalWorkIds);

                // load product config
                that.LoadShowData(articleReference);
            })
            .fail(function () {
                alerts.error();
            });
    };

    that.LoadEditOrderData = function (articleReference, orderPositionId) {
        pageModelHndl.EditOrderPositionId(orderPositionId);

        pageModelHndl.SubmitText(EditOrderSave);

        pageModelHndl.EditData([]);
        pageModelHndl.IsEditDataAvailable(false);
        pageModelHndl.IsShowDataAvailable(false);
        pageModelHndl.OrderPositionId(orderPositionId);
        pageModelHndl.CurrentHash("#/editorder/" + articleReference + "/" + orderPositionId);

        that.resolveArticleReference(articleReference).done(function(data) {
            if (!data.Success) {
                pageModelHndl.ShowData([]);
                pageModelHndl.IsShowDataAvailable(false);
                document.location.hash = "/";
                $("#errorDiv2").fadeIn("slow").delay(3000).fadeOut("fast");
                return;
            }

            pageModelHndl.EditOrderData(data);
            pageModelHndl.IsEditOrderDataAvailable(true);

            pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues(data.Model.SelectedValues);
            pageModelHndl.pProductModel.UpdateProductModel();

            if (pageModelHndl.IsProductModelPopulated()) {
                pageModelHndl.CurrentAmount(data.Model.Amount);
                pageModelHndl.pProductModel.RePopulateProductModel(data.Model.SelectedValues);
            } else {
                that.LoadProductModelData();
            }
        }).fail(function () {
            alerts.error();
        });

        $.get(ajaxUrls.order.GetCouponForOrderPosition, { orderPositionId: orderPositionId })
            .done(function (data) {
                if (data != null) {
                    var infoModel = new CouponInfoModel(pageModelHndl);
                    infoModel.Populate(data);
                    pageModelHndl.EditCoupon(infoModel);
                }
            }).fail(function () {
                alerts.error();
            });
    };

    that.LoadTemplateData = function (editId) {
        pageModelHndl.ShowData([]);
        pageModelHndl.IsShowDataAvailable(false);
        pageModelHndl.SubmitText(SubmitTextShoppingCart);
        pageModelHndl.EditId("-1");
        pageModelHndl.EditData([]);
        pageModelHndl.IsEditDataAvailable(false);

        $.get(ajaxUrls.shoppingCart.GetItem, { position: editId }, function (data) {
            if (!data.Success) {
                pageModelHndl.EditData([]);
                pageModelHndl.IsEditDataAvailable(false);
                document.location.hash = "/";
                return;
            }

            pageModelHndl.EditData(data.Model);
            pageModelHndl.IsEditDataAvailable(true);

            if (pageModelHndl.IsProductModelPopulated()) {
                pageModelHndl.CurrentAmount(data.Model.Amount);
                pageModelHndl.pProductModel.RePopulateProductModel(data.Model.ProductConfig, true, data.Model.Extensions);
            } else {
                that.LoadProductModelData();
            }
        }).fail(function () {
            alerts.error();
        });
    };

    var sammy = Sammy(function() {
        this.get("#/",
            function() {
                that.LoadProductModelData();
            });

        this.get("#/show/:articleReference",
            function() {
                if (!that.IsPaused()) {
                    that.LoadShowData(this.params.articleReference);
                }
            });

        this.get("#/edit/:editId",
            function() {
                that.LoadPositionEditData(this.params.editId);
            });

        this.get("#/editorder/:editId/:orderPositionId",
            function() {
                that.LoadEditOrderData(this.params.editId, this.params.orderPositionId);
            });

        this.get("#/template/:templateId",
            function() {
                that.LoadTemplateData(this.params.templateId);
            });

        // Overwrites not found behaviour of Sammy
        // for sammy only above defined 'routes' are valid 
        this.notFound = function(verb, path) {
            console.warn(['sammy route: 404 Not Found', verb, path].join(' '));
            return true;
        };
    });
    sammy.raise_errors = true;
    sammy.run();
};